import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import axios from "axios";
import Modal from "../components/Modal";
import MasaAyarlari from "../components/MasaAyarlari";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import AccessDenied from "../components/AccessDenied";
import { base_url } from "../api/index";
import { Helmet } from "react-helmet";
import { fetchTableOrderStocks } from "../redux/stocksSlice";
import { useDispatch, useSelector } from "react-redux";
import ExpiredTablesAlert from "../components/ExpiredTablesAlert";
import soundFile from "../assets/sound1.mp3";
import { AnimatePresence, motion } from "motion/react";
import { LayoutDashboard, Search } from "lucide-react";
import { TableCard } from "../components/pos/TableCard";
import { TableRightDock } from "../components/pos/TableRightDock";
import { PosLoader } from "../components/pos/PosLoader";
// AnimatePresence — sadece sağ dock için (giriş/çıkış animasyonu)
import { useTableRealtimeWithFallback } from "../hook/useTableRealtimeWithFallback";
import { useI18n } from "../i18n/I18nContext";
import {
  scopeTablesToGroup,
  normalizeGroupId,
  isStaleTableResponse,
} from "../api/pos/tableGroupScope";
// --- Three.js floor plan (hidden for now, kept for future use) ---
// import { RestaurantFloorPlan } from "../components/pos/RestaurantFloorPlan";

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const Masalar = () => {
  const { t } = useI18n();
  const [ActiveUser, setActiveUser] = useState(false);
  // RƏQƏM olaraq saxlanılır.
  //
  // Əvvəl `localStorage.getItem("masaType") || 0` idi, yəni yaddaşda dəyər
  // varsa MƏTN ("3") qayıdırdı. Üç nəticəsi vardı: `masaType === section.id`
  // heç bir tabı aktiv göstərmirdi, `groupId === 0` yoxlaması "0" üçün
  // işləmirdi, və mount effekti `setMasaType(Number(...))` edən kimi dəyər
  // "dəyişmiş" sayılıb ikinci dəfə fetch atırdı.
  const [masaType, setMasaType] = useState<number>(() => {
    const stored = Number(localStorage.getItem("masaType"));
    return Number.isFinite(stored) ? stored : 0;
  });
  const [showDetail, setShowDetail] = useState(null);
  const [masaAyarlar, setMasaAyarlar] = useState(false);
  const [groups, setGroups] = useState<any[]>([]);
  const [tables, setTables] = useState<any[]>([]);
  const [accessDenied, setAccessDenied] = useState(false);
  const [role, setrole] = useState(localStorage.getItem("role"));
  const [loading, setLoading] = useState(false);
  const [tableItemData, setTableItemData] = useState<any>({});
  const tablesRef = useRef([]);
  const masaTypeRef = useRef(0);
  const tableRequestSeq = useRef(0);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  // Ödəniş modalı (HesapKes) birbaşa açılanda true — "Ödeme" sürətli düyməsi üçün.
  const [paymentMode, setPaymentMode] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { allItems, orders, error } = useSelector((state: any) => state.stocks);

  // Restaurant ID — localStorage'dan al (NewOrders.tsx ile aynı pattern)
  const restaurantId = useMemo(() => {
    const saved = localStorage.getItem("restaurant_info");
    if (!saved) return null;
    try {
      return JSON.parse(saved)?.id ?? null;
    } catch {
      return null;
    }
  }, []);

  const [tableColors, setTableColors] = useState({
    empty: "#ff0000",
    booked: "#834e4e",
  });

  const getTableById = useCallback(
    (tableId) => tables.find((t) => t.id === tableId),
    [tables],
  );

  const handleTableNavigation = (tableId, openSettings = false) => {
    const table = getTableById(tableId);

    if (!table) return;

    if (openSettings) {
      localStorage.setItem(`masa_siparis_${tableId}_openPsModal`, "true");
      localStorage.setItem(`masa_siparis_${tableId}_openPsSettings`, "true");
      const isExpired =
        table.ps_timer_status === "expired" || Number(table.expiredMinutes) > 0;
      if (isExpired) {
        localStorage.setItem(`table_${tableId}_isExpired`, "true");
      }
    } else {
      const savedIsExpired = localStorage.getItem(`table_${tableId}_isExpired`);
      const savedEndTime = localStorage.getItem(`table_${tableId}_endTime`);
      const currentTime = Date.now();
      const isTableExpired =
        savedIsExpired === "true" ||
        (savedEndTime && currentTime > parseInt(savedEndTime));

      if (isTableExpired) {
        localStorage.setItem(`table_${tableId}_isExpired`, "true");
      }
      localStorage.removeItem(`masa_siparis_${tableId}_openPsModal`);
      localStorage.removeItem(`masa_siparis_${tableId}_openPsSettings`);
    }

    // SPA naviqasiyası — əvvəl `window.location.href` idi, yəni hər "Sifariş başlat"
    // klikləməsi bütün tətbiqi yenidən yükləyirdi (bundle təkrar parse, /me yenidən
    // çəkilir, ProtectedRoute o müddətdə `null` render edir → 1-3 saniyə AĞ EKRAN).
    navigate(`/masa-siparis/${tableId}`);
  };

  // Fetch table groups
  const fetchGroups = async () => {
    try {
      const response = await axios.get(
        `${base_url}/table-groups`,
        getHeaders(),
      );
      setGroups(response.data);
    } catch (error: any) {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.message ===
        "User does not belong to any  active restaurant."
      ) {
        setActiveUser(true);
      }
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.message === "Forbidden"
      ) {
        // setAccessDenied(true);
      } else {
        console.error("Error loading customers:", error);
      }
    }
  };

  // Fetch tables
  const fetchTables = async (groupId, { silent = false } = {}) => {
    const requestedGroup = normalizeGroupId(groupId);
    // Hər sorğuya növbə nömrəsi. Cavab gələndə hələ də ƏN SON sorğu olub
    // olmadığını yoxlayırıq.
    //
    // NİYƏ: "Salon" → "Teras" sürətlə basılanda iki sorğu paralel gedir.
    // Salon cavabı gec gəlsə Teras nəticəsinin ÜZƏRİNƏ yazılırdı — ekranda
    // Teras tabı seçili qalır, masalar isə Salonun olurdu. Oflayn/yavaş
    // şəbəkədə bu hər dəfə baş verirdi.
    const seq = ++tableRequestSeq.current;
    try {
      if (!silent) setLoading(true);
      const response = await axios.get(`${base_url}/tables`, {
        ...getHeaders(),
        params: requestedGroup === 0 ? {} : { table_group_id: requestedGroup },
      });

      // Köhnəlmiş cavab: ya daha yeni sorğu başlayıb, ya da istifadəçi artıq
      // başqa qrupdadır. Hər iki halda bu məlumat ekrana AİD DEYİL.
      if (
        isStaleTableResponse({
          seq,
          latestSeq: tableRequestSeq.current,
          requestedGroup,
          currentGroup: masaTypeRef.current,
        })
      ) {
        return;
      }

      const rawTables = response?.data?.tables;
      const nextTables = Array.isArray(rawTables) ? rawTables : null;
      const prevTables = tablesRef.current || [];

      // İnternet itib-gələndə (reconnect/polling = silent) gateway/pos_local bəzən
      // müvəqqəti boş və ya düzgün-olmayan cavab qaytara bilər. Belə halda mövcud
      // masaları SAXLA — əks halda grid boşalır və yalnız əl ilə refresh-lə qayıdır.
      // Yalnız açıq (silent olmayan: ilk yükləmə / bölmə dəyişimi / refresh) fetch
      // gridi boşalda bilər — onlar avtoritetdir.
      const wouldWipe =
        nextTables === null ||
        (silent && nextTables.length === 0 && prevTables.length > 0);

      if (!wouldWipe) {
        const prevJson = JSON.stringify(prevTables);
        const nextJson = JSON.stringify(nextTables);
        if (prevJson !== nextJson) {
          setTables(nextTables);
        }
      }

      const nextEmpty =
        localStorage.getItem("empty_table_color") ||
        response.data.empty_table_color;
      const nextBooked =
        localStorage.getItem("booked_table_color") ||
        response.data.booked_table_color;

      setTableColors((prev) => {
        const shouldUpdate =
          prev.empty !== nextEmpty || prev.booked !== nextBooked;
        return shouldUpdate
          ? {
            empty: nextEmpty,
            booked: nextBooked,
          }
          : prev;
      });
    } catch (error: any) {
      console.error("Error loading tables:", error);
    } finally {
      if (!silent && seq === tableRequestSeq.current) setLoading(false);
    }
  };

  useEffect(() => {
    tablesRef.current = tables;
  }, [tables]);

  // Seçili qrup ref-də — `fetchTables` cavab gələndə HAZIRKI qrupu bilməlidir,
  // çağırış anındakını yox.
  useEffect(() => {
    masaTypeRef.current = masaType;
  }, [masaType]);

  // ✅ Realtime WebSocket — polling yerine push-based güncellemeler
  useTableRealtimeWithFallback(
    restaurantId,
    {
      onStatusChanged: (data) => {
        setTables((prev) =>
          prev.map((t) =>
            t.id === data.table_id
              ? {
                ...t,
                is_available: data.is_available ? 1 : 0,
                book_time: data.book_time,
                user_name: data.user_name,
                total_price: data.total_price,
              }
              : t,
          ),
        );
      },

      onTableCreated: (_data) => {
        // Yeni masa eklendi — tam veri için REST'ten çek
        fetchTables(masaType, { silent: true });
      },

      onTableUpdated: (data) => {
        setTables((prev) =>
          prev.map((t) =>
            t.id === data.table_id ? { ...t, ...data.changes } : t,
          ),
        );
      },

      onTableDeleted: (data) => {
        setTables((prev) => prev.filter((t) => t.id !== data.table_id));
      },

      onTableTransferred: (_data) => {
        // İki masa değişti — doğru state için yeniden çek
        fetchTables(masaType, { silent: true });
      },
    },
    // Fallback fetch — WS kesilirse veya reconnect olursa çağrılır
    () => fetchTables(masaType, { silent: true }),
  );

  useEffect(() => {
    fetchGroups();

    // `masaType` artıq useState initializer-ində yaddaşdan oxunur.
    // Burada təkrar `setMasaType` etmək ikinci (lazımsız) fetch doğururdu.

    // Navbar'dan gelen arama eventini dinle
    const handleNavSearch = (e: CustomEvent) => {
      setSearchQuery(e.detail || "");
    };
    window.addEventListener("masalar-search", handleNavSearch as EventListener);
    return () => window.removeEventListener("masalar-search", handleNavSearch as EventListener);
  }, []);

  useEffect(() => {
    fetchTables(masaType);
    localStorage.setItem("masaType", String(masaType));
  }, [masaType]);

  useEffect(() => {
    if (id) {
      dispatch(fetchTableOrderStocks(id as any));
    }
  }, [id, dispatch]);

  // Seçili bölməyə aid olmayan masa heç vaxt göstərilmir — səbəb və semantika
  // üçün bax: `api/pos/tableGroupScope.ts`.
  const groupScopedTables = useMemo(
    () => scopeTablesToGroup(tables, masaType),
    [tables, masaType],
  );

  // --- Map API tables to card-friendly format (memoized) ---
  const mappedTables = useMemo(() => {
    return groupScopedTables.map((table) => {
      const isEmpty = table.is_available;
      const isReserved = table.book_time && isEmpty;
      let status = "empty";
      if (isReserved) status = "reserved";
      else if (!isEmpty) status = "occupied";

      const groupName =
        groups.find((g) => g.id === table.table_group_id)?.name || "";

      const orders = table.orders || table.order_items || [];
      const itemCount =
        orders.reduce((sum, order) => {
          if (order.stocks && Array.isArray(order.stocks)) {
            return (
              sum +
              order.stocks.reduce(
                (qty, stock) => qty + Number(stock.quantity || 1),
                0,
              )
            );
          }
          return sum + 1;
        }, 0) || orders.length;

      return {
        id: table.id,
        number: table.name?.replace(/[^0-9]/g, "") || String(table.id),
        displayName: table.name,
        status,
        guests: table.guest_count || undefined,
        duration: table.book_time || undefined,
        total: Number(table.total_price) || 0,
        section: groupName,
        waiter: table.waiter_name || undefined,
        bookTime: table.book_time || undefined,
        hasWarning:
          table.ps_timer_status === "expired" ||
          Number(table.expiredMinutes) > 0,
        orders,
        itemCount,
        _raw: table,
      };
    });
  }, [groupScopedTables, groups]);

  const filteredTables = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    return mappedTables.filter((t) => {
      const statusMatch =
        selectedStatus === "all" || t.status === selectedStatus;
      const searchMatch =
        !query ||
        [t.number, t.displayName, t.section, t.waiter]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(query));
      return statusMatch && searchMatch;
    });
  }, [mappedTables, selectedStatus, searchQuery]);

  // Sağ dock və detal modalı klik anındakı SNAPSHOT-u yox, `tables`-dəki canlı
  // sətri göstərsin — real-time yeniləmə (məhsul əlavə/sil, total, status) açıq
  // panel/modal üzərində dərhal əks olunsun.
  const selectedTableLive = useMemo(() => {
    if (!selectedTable) return null;
    const id = (selectedTable as any).id;
    return mappedTables.find((t) => t.id === id) ?? selectedTable;
  }, [mappedTables, selectedTable]);

  const tableItemDataLive = useMemo(() => {
    if (!tableItemData?.id) return tableItemData;
    return tables.find((t) => t.id === tableItemData.id) ?? tableItemData;
  }, [tables, tableItemData]);

  // --- Stats (memoized) ---
  const stats = useMemo(() => {
    let occupied = 0;
    let empty = 0;
    let revenue = 0;
    for (const t of mappedTables) {
      if (t.status === "occupied") {
        occupied++;
        revenue += t.total || 0;
      } else if (t.status === "empty" || t.status === "reserved") {
        empty++;
      }
    }
    return { total: mappedTables.length, occupied, empty, revenue };
  }, [mappedTables]);

  // --- Section tabs from groups (memoized) ---
  const sections = useMemo(
    () => [
      { id: 0, name: t("masalar.all") },
      ...groups.map((g) => ({ id: g.id, name: g.name })),
    ],
    [groups, t],
  );

  const handleTableClick = useCallback((cardTable) => {
    setSelectedTable((prev: any) =>
      prev?.id === cardTable.id ? null : cardTable,
    );
  }, []);

  // Ödəniş modalını (HesapKes) birbaşa aç — TableRightDock "Ödeme" və
  // PosTablePage "Ödeme Al" üçün. Detal modalı ilə eyni Modal işlədilir, sadəcə
  // başlanğıc görünüş "hesapKes" olur.
  const handleOpenPayment = (table: any) => {
    if (!table) return;
    setTableItemData(table._raw || table);
    setPaymentMode(true);
    setShowDetail(table.id);
  };

  // PosTablePage "Ödeme Al" → /masalar-a state ilə qayıdır; burada həmin masanın
  // ödəniş modalını avtomatik açırıq. Ref qoruması: tables realtime yenilənəndə
  // effekt təkrar işləsə belə yalnız bir dəfə açılır (istifadəçi bağlayandan sonra
  // yenidən açılmasın).
  const paymentAutoOpenedRef = useRef(false);
  useEffect(() => {
    const payId = (location.state as any)?.openPaymentForTable;
    if (payId == null || tables.length === 0 || paymentAutoOpenedRef.current) return;
    const t = tables.find((x: any) => String(x.id) === String(payId));
    if (t) {
      paymentAutoOpenedRef.current = true;
      handleOpenPayment(t);
      window.history.replaceState({}, document.title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, tables]);

  if (accessDenied) return <AccessDenied onClose={setAccessDenied} />;

  return (
    <>
      <Helmet>
        <title>{t("masalar.pageTitle")}</title>
        <meta
          name="description"
          content={t("masalar.pageDesc")}
        />
      </Helmet>

      {/*
        TEK RENK DARK MODE — GERÇEK ÇÖZÜM:
        index.css'teki `.dark .bg-white { ... !important }` ve `.dark .bg-gray-50`
        kuralları Tailwind'in `dark:bg-[...]` class'ını eziyor. Çözüm: bg sınıflarını
        kaldırıp inline style ile `var(--bg-body)` kullanmak — inline styles asla
        global !important kuralları tarafından ezilmez. Light/dark otomatik çözülür.
      */}
      <div
        className="h-[calc(100vh-5rem)] flex flex-col relative overflow-hidden"
        style={{ backgroundColor: "var(--bg-body)" }}
      >
        {/* Subtle Ambient Background Orbs — exact match from TablesPage.tsx design */}
        <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-[#ff8a00]/10 dark:bg-[#ff8a00]/15 blur-[120px] mix-blend-screen pointer-events-none" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-orange-600/5 dark:bg-orange-600/10 blur-[120px] mix-blend-screen pointer-events-none" />

        {/* Main Tables Area */}
        <div className="relative z-10 flex-1 flex flex-col overflow-hidden">
          <ExpiredTablesAlert
            tables={tables}
            onTableClick={(tableId) => handleTableNavigation(tableId, false)}
            soundFile={soundFile}
          />

          <div className="bg-white/60 dark:bg-[#09090b]/60 backdrop-blur-3xl border-b border-gray-200/50 dark:border-white/5 px-8 py-5 flex-shrink-0">
            <div className="flex flex-col xl:flex-row xl:items-end justify-between gap-6 mb-8">
              <div>
                <div className="flex items-center gap-2 mb-1.5">
                  <LayoutDashboard className="w-5 h-5 text-gray-400 dark:text-gray-500" />
                  <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                    {t("masalar.title")}
                  </h1>
                </div>
                <div className="flex flex-wrap items-center gap-4 text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ff8a00] shadow-[0_0_10px_rgba(255,138,0,0.8)]" />
                    <span>{stats.occupied} {t("masalar.occupied")}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-300 dark:bg-white/30" />
                    <span>{stats.empty} {t("masalar.empty")}</span>
                  </div>
                  <div className="h-3 w-px bg-gray-300 dark:bg-gray-700 mx-1" />
                  <span>{stats.total} {t("masalar.total")}</span>
                  <div className="h-3 w-px bg-gray-300 dark:bg-gray-700 mx-1" />
                  <span className="text-gray-900 dark:text-gray-200 tracking-tight">
                    ₼{Number(stats.revenue || 0).toLocaleString("tr-TR")} {t("masalar.revenue")}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="flex p-1 bg-gray-100 dark:bg-white/5 rounded-full border border-gray-200/50 dark:border-white/5 backdrop-blur-xl">
                  {[
                    { id: "all", label: t("masalar.all") },
                    { id: "occupied", label: t("masalar.occupied") },
                    { id: "empty", label: t("masalar.empty") },
                  ].map((status) => (
                    <button
                      key={status.id}
                      onClick={() => setSelectedStatus(status.id)}
                      className={`relative px-5 py-1.5 rounded-full text-sm font-semibold transition-colors z-10 ${selectedStatus === status.id
                        ? "text-white"
                        : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                        }`}
                    >
                      {selectedStatus === status.id && (
                        <motion.div
                          layoutId="tablesStatusPill"
                          className="absolute inset-0 bg-[#ff8a00] rounded-full shadow-[0_2px_10px_rgba(255,138,0,0.3)] -z-10"
                          transition={{
                            type: "spring",
                            stiffness: 400,
                            damping: 30,
                          }}
                        />
                      )}
                      {status.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-8 relative overflow-x-auto scrollbar-hide">
              {sections.map((section) => {
                const active = masaType === section.id;
                return (
                  <button
                    key={section.id}
                    onClick={() => setMasaType(section.id)}
                    className={`relative pb-3 text-sm font-semibold transition-colors whitespace-nowrap ${active
                      ? "text-gray-900 dark:text-white"
                      : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                      }`}
                  >
                    {section.name}
                    {active && (
                      <motion.div
                        layoutId="tablesSectionIndicator"
                        className="absolute bottom-[-1px] left-0 right-0 h-[2px] bg-[#ff8a00] rounded-t-full shadow-[0_-2px_8px_rgba(255,138,0,0.5)]"
                      />
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Loading — tüm sayfalarda aynı PosLoader (dairesel spinner) */}
          {loading && (
            <div className="flex-1 flex justify-center items-center">
              <PosLoader size="lg" label={t("masalar.loading")} />
            </div>
          )}

          {/* Tables Grid — AnimatePresence kaldırıldı (TableCard artık motion değil) */}
          <div className="flex-1 overflow-y-auto p-8">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-6 pb-20">
              {filteredTables.map((table) => (
                <TableCard
                  key={table.id}
                  table={table}
                  isSelected={selectedTable?.id === table.id}
                  onClick={handleTableClick}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Right Action Dock */}
        <AnimatePresence>
          {selectedTableLive && (
            <TableRightDock
              table={selectedTableLive}
              onClose={() => setSelectedTable(null)}
              onOpenPOS={() => handleTableNavigation(selectedTableLive.id)}
              onOpenPayment={() => handleOpenPayment(selectedTableLive)}
              onShowDetail={(t) => {
                setTableItemData(t._raw || t);
                setShowDetail(t.id);
              }}
            />
          )}
        </AnimatePresence>
      </div>

      {showDetail != null && (
        <Modal
          type={true}
          groups={groups}
          tableItemData={tableItemDataLive}
          setShowDetail={(v: any) => {
            setShowDetail(v);
            if (v == null) setPaymentMode(false);
          }}
          _modalMain={paymentMode ? "hesapKes" : "main"}
        />
      )}
      {masaAyarlar && <MasaAyarlari setMasaAyarlar={setMasaAyarlar} />}
    </>
  );
};

export default Masalar;
